/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_LoginInputs */

const es_navbar_login = /** @type {(inputs: Navbar_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar Sesión`)
};

const en_navbar_login = /** @type {(inputs: Navbar_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log In`)
};

/**
* | output |
* | --- |
* | "Log In" |
*
* @param {Navbar_LoginInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_login = /** @type {((inputs?: Navbar_LoginInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_LoginInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_login(inputs)
	return en_navbar_login(inputs)
});
export { navbar_login as "navbar.login" }